import { FormEvent } from "react";
import { Stack, TextField } from "@buildo/bento-design-system";

export interface AdminField {
  name: string;
  label: string;
  value: string;
  required?: boolean;
  multiline?: boolean;
}

interface AdminResourceFormProps {
  title: string;
  fields: AdminField[];
  onChange: (name: string, value: string) => void;
  onSubmit: (e: FormEvent) => void;
  onCancel: () => void;
  submitLabel: string;
}

function AdminResourceForm({
  title,
  fields,
  onChange,
  onSubmit,
  onCancel,
  submitLabel,
}: AdminResourceFormProps) {
  return (
    <div className="admin-form-panel">
      <h2 className="h1-text" style={{ marginBottom: 16 }}>
        {title}
      </h2>
      <form onSubmit={onSubmit}>
        <Stack space={16}>
          {fields.map((field) => (
            <TextField
              key={field.name}
              label={field.required ? `${field.label} *` : field.label}
              name={field.name}
              value={field.value}
              onChange={(value) => onChange(field.name, value)}
            />
          ))}
        </Stack>
        <div className="admin-form-actions">
          <button type="submit" className="admin-btn admin-btn--primary">
            {submitLabel}
          </button>
          <button type="button" className="admin-btn" onClick={onCancel}>
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}

export default AdminResourceForm;
